import axios from "axios";

export const http = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("mp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Qualcosa è andato storto. Riprova.";
};

export const euro = (n) =>
  n === null || n === undefined || n === ""
    ? "Su richiesta"
    : new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n) || 0);
